import OwnLocation from "./Location/OwnLocation";
import SpecialLocation from "./Location/SpecialLocation";
import PieStudio from "./Location/PieStudio";

export default function Location({setData, form}) {

    // locations: pieStudio, ownLocation, specialLocation
    const loadComponent = () => {
        let location = form?.location ?? 'pieStudio';

        if (location === 'ownLocation') {
            return (<OwnLocation setData={setData} form={form}/>);
        }

        if (location === 'specialLocation') {
            return (<SpecialLocation setData={setData} form={form}/>);
        }

        return (<PieStudio setData={setData} form={form}/>);
    }

    return (
        <>
            <div className={'location_type_container'}>
                <button className={'type' + (form?.location === 'pieStudio' ? ' type_selected' : '')}
                        onClick={(e) => setData({location: 'pieStudio'})}>
                    PIE Studios
                </button>
                <button className={'type' + (form?.location === 'ownLocation' ? ' type_selected' : '')}
                        onClick={(e) => setData({location: 'ownLocation'})}>
                    I have my own location
                </button>
                <button className={'type' + (form?.location === 'specialLocation' ? ' type_selected' : '')}
                        onClick={(e) => setData({location: 'specialLocation'})}>
                    Find me a location
                </button>
            </div>
            <div>
                {loadComponent()}
            </div>
        </>
    );
}